// frontend/src/components/StatusBadge.jsx
// ----------------------------------------------------
// Status Badge - Shows live connection & system status
// Modern compact design
// ----------------------------------------------------

import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../config";

export default function StatusBadge() {
  const [status, setStatus] = useState({
    kiteConnected: false,
    schedulerRunning: false,
    schedulerMode: "stopped",
    paperBrokerRunning: false,
    equity: 0,
    pnl: 0,
    commodity: 0,
    timestamp: null,
  });

  useEffect(() => {
    let mounted = true;

    const fetchStatus = async () => {
      try {
        const { data } = await axios.get(
          `${API_BASE}/strategy/status`
        );
        if (data?.ok && mounted) {
          setStatus(data);
        }
      } catch (err) {
        console.warn("⚠️ Could not fetch live status:", err.message);
        if (mounted) {
          setStatus((prev) => ({
            ...prev,
            kiteConnected: false,
            schedulerRunning: false,
          }));
        }
      }
    };

    fetchStatus();
    const id = setInterval(fetchStatus, 5000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  const pnlValue = Number(status.pnl) || 0;
  const isPositive = pnlValue >= 0;

  return (
    <div className="status-badge-container">
      {/* Connection indicator */}
      <div className="status-item">
        <span
          className={`status-dot ${status.kiteConnected ? "online" : "offline"}`}
        ></span>
        <span className="status-text">
          {status.kiteConnected ? "Connected" : "Offline"}
        </span>
      </div>

      {/* Scheduler status */}
      <div className="status-item">
        <span className="status-icon">⚡</span>
        <span className="status-text">
          {status.schedulerRunning
            ? status.schedulerMode?.toUpperCase()
            : "Stopped"}
        </span>
      </div>

      <style>{`
        .status-badge-container {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid var(--color-border);
          border-radius: var(--radius-full);
          font-size: 0.8rem;
        }

        .status-item {
          display: flex;
          align-items: center;
          gap: 6px;
          color: var(--color-text-secondary);
        }

        .status-icon {
          font-size: 0.9rem;
        }

        .status-text {
          font-weight: 500;
        }

        .status-pnl {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: var(--radius-sm);
          font-family: var(--font-family-mono);
          font-weight: 600;
        }

        .status-pnl.positive {
          background: var(--color-success-bg);
          color: var(--color-success-light);
        }

        .status-pnl.negative {
          background: var(--color-danger-bg);
          color: var(--color-danger-light);
        }

        .pnl-label {
          font-size: 0.7rem;
          opacity: 0.8;
        }

        .pnl-value {
          font-size: 0.85rem;
        }

        @media (max-width: 768px) {
          .status-badge-container {
            font-size: 0.75rem;
            gap: 10px;
            padding: 6px 12px;
          }
        }
      `}</style>
    </div>
  );
}
